var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "title-settings" } }, [
    _c("div", { staticClass: "form-field" }, [
      _c(
        "label",
        { staticClass: "form-label", attrs: { for: "title-input" } },
        [_vm._v("Başlık Metni")]
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.item.title.titleText,
            expression: "item.title.titleText",
          },
        ],
        staticClass: "form-input",
        attrs: { type: "text", id: "title-input", placeholder: "Başlık" },
        domProps: { value: _vm.item.title.titleText },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.item.title, "titleText", $event.target.value)
            },
            function ($event) {
              return _vm.updateTitleText(_vm.item.title.titleText)
            },
          ],
        },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-field" }, [
      _c(
        "label",
        { staticClass: "form-label", attrs: { for: "subtitle-input" } },
        [_vm._v("Alt Başlık Metni")]
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.item.title.subTitle,
            expression: "item.title.subTitle",
          },
        ],
        staticClass: "form-input",
        attrs: {
          type: "text",
          id: "subtitle-input",
          placeholder: "Alt Başlık",
        },
        domProps: { value: _vm.item.title.subTitle },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.item.title, "subTitle", $event.target.value)
            },
            function ($event) {
              return _vm.updateSubTitleText(_vm.item.title.subTitle)
            },
          ],
        },
      }),
      _vm._v(" "),
      _c("small", { staticClass: "form-description" }, [
        _vm._v("Başlığın altına daha küçük bir metin ekle"),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-field" }, [
      _c("label", { staticClass: "form-label" }, [_vm._v("Başlık Boyutu")]),
      _vm._v(" "),
      _c("div", { staticClass: "button-group" }, [
        _c(
          "button",
          {
            staticClass: "button",
            class: { active: _vm.titleSize === "default" },
            on: {
              click: function ($event) {
                return _vm.updateTitleSize("default")
              },
            },
          },
          [_vm._v("\n                Varsayılan\n            ")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "button",
            class: { active: _vm.titleSize === "wide" },
            on: {
              click: function ($event) {
                return _vm.updateTitleSize("wide")
              },
            },
          },
          [_vm._v("Geniş\n            ")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "button",
            class: { active: _vm.titleSize === "small" },
            on: {
              click: function ($event) {
                return _vm.updateTitleSize("small")
              },
            },
          },
          [_vm._v("\n                Küçük\n            ")]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-field" }, [
      _c("label", { staticClass: "form-label" }, [_vm._v("Metin Hizalama")]),
      _vm._v(" "),
      _c("div", { staticClass: "button-group" }, [
        _c(
          "button",
          {
            staticClass: "button",
            class: { active: _vm.textAlign === "left" },
            on: {
              click: function ($event) {
                return _vm.updateTextAlign("left")
              },
            },
          },
          [_vm._v("Sol\n            ")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "button",
            class: { active: _vm.textAlign === "center" },
            on: {
              click: function ($event) {
                return _vm.updateTextAlign("center")
              },
            },
          },
          [_vm._v("\n                Orta\n            ")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "button",
            class: { active: _vm.textAlign === "right" },
            on: {
              click: function ($event) {
                return _vm.updateTextAlign("right")
              },
            },
          },
          [_vm._v("Sağ\n            ")]
        ),
      ]),
      _vm._v(" "),
      _c("small", { staticClass: "form-description" }, [
        _vm._v("Bu başlığın yatay olarak nasıl hizalanacağını seçin."),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }